import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import CategoryPage from './pages/CategoryPage';
import ProjectPage from './components/ProjectPage';
import NotFound from './pages/NotFound';
import { projectData } from './data/projectData';

const SITE_TITLE = 'David Robert : : Creative Technologist';

// Works out a readable page title and type for each route, so Google
// Analytics can tell pages apart (it groups the Pages report by title).
function describePage(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/';

  if (path === '/') return { title: SITE_TITLE, type: 'home' };
  if (path === '/about') return { title: `About : : ${SITE_TITLE}`, type: 'about' };

  for (const key of Object.keys(projectData)) {
    if (path === `/${key}`) {
      return { title: `${projectData[key].title} : : ${SITE_TITLE}`, type: 'category' };
    }
  }

  const projectMatch = path.match(/^\/projects\/([^/]+)$/);
  if (projectMatch) {
    const projectId = decodeURIComponent(projectMatch[1]);
    for (const key of Object.keys(projectData)) {
      const project = projectData[key].projects.find(
        p => p.link === `/projects/${projectId}`
      );
      if (project) {
        return {
          title: `${project.title} : : ${SITE_TITLE}`,
          type: 'project',
          projectId,
          category: key,
        };
      }
    }
  }

  return { title: `Not Found : : ${SITE_TITLE}`, type: 'not_found' };
}

function Analytics() {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;

    if (lastTrackedPath.current === pagePath) {
      return;
    }

    lastTrackedPath.current = pagePath;

    const page = describePage(location.pathname);
    document.title = page.title;

    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_location: window.location.href,
        page_path: pagePath,
        page_title: page.title,
        page_type: page.type,
        ...(page.projectId && {
          project_id: page.projectId,
          project_category: page.category,
        }),
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Analytics />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/work" element={<CategoryPage categoryData={projectData.work} />} />
<Route path="/art" element={<CategoryPage categoryData={projectData.art} />} />
          <Route path="/projects/:projectId" element={<ProjectPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
